import React from 'react'
import PropTypes from 'prop-types'
import Text from '@bufferapp/ui/Text'
import Tooltip from '@bufferapp/ui/Tooltip'
import { grayDarker } from '@bufferapp/ui/style/colors'

import Counter from '~/modules/post/components/Counter/Counter'
import PostThumbnail from '~/modules/post/components/PostThumbnail'
import { TextPlaceholder } from '~/shared/components'
import { customGrayA } from '~/shared/styles/colors'
import { formatTimeAgo } from '~/modules/post/utils'
import { shortenText } from '~/shared/utils/strings'
import { SERVICE_DEFAULTS } from '~/app/constants'

import {
  Wrapper,
  ImageContainer,
  InfoContainer,
  CountersContainer,
  TimeAgo,
  PlaceholderWrapper,
  Status,
} from './styles'

/**
 *
 */
const COUNTER_COLORS = {
  icon: customGrayA,
  value: grayDarker,
}

const MAX_POST_TEXT_SIZE = 150

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'post' implicitly has an 'any' typ... Remove this comment to see the full error message
const PostDetails = ({ post, animated = false }) => {
  const {
    text,
    mediaUrl: image,
    permalink: postURL,
    createdAt,
    totalLikes = 0,
    totalPendingComments = 0,
    backfilling = false,
    dismissingAll = false,
    channelService,
  } = post || {}

  const renderPlaceholderText = () => (
    <PlaceholderWrapper>
      <TextPlaceholder width="100%" height="13px" />
      <TextPlaceholder width="90%" height="13px" />
    </PlaceholderWrapper>
  )

  const renderPlaceholderTime = () => (
    <PlaceholderWrapper>
      <TextPlaceholder width="10%" height="10px" />
    </PlaceholderWrapper>
  )

  const createdAgo = formatTimeAgo(createdAt, new Date(), false)
  const placeholder = !post
  const showLikesCounter = channelService === 'instagram' || placeholder
  const serviceName = channelService
    ? // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      SERVICE_DEFAULTS[channelService].label
    : null

  return (
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    <Wrapper animated={animated && !post}>
      <Tooltip
        label={serviceName ? `View post on ${serviceName}` : ''}
        position="top"
      >
        <ImageContainer>
          <PostThumbnail src={image} postURL={postURL} />
        </ImageContainer>
      </Tooltip>
      <InfoContainer>
        {placeholder ? (
          renderPlaceholderText()
        ) : (
          <Text type="p" color={grayDarker}>
            {shortenText(text, MAX_POST_TEXT_SIZE)}
          </Text>
        )}
        <CountersContainer>
          {showLikesCounter && (
            <Counter
              type="likes"
              value={totalLikes}
              colors={COUNTER_COLORS}
              placeholder={placeholder}
            />
          )}
          <Counter
            type="total-comments"
            value={totalPendingComments}
            colors={COUNTER_COLORS}
            placeholder={placeholder}
          />
        </CountersContainer>
        {placeholder ? (
          renderPlaceholderTime()
        ) : (
          <TimeAgo>
            {createdAgo &&
              createdAgo.charAt(0).toUpperCase() + createdAgo.slice(1)}
          </TimeAgo>
        )}
      </InfoContainer>
      {dismissingAll && <Status>Dismissing all comments</Status>}

      {backfilling && !dismissingAll && <Status>Loading comments...</Status>}
    </Wrapper>
  )
}

PostDetails.propTypes = {
  post: PropTypes.object,
  animated: PropTypes.bool,
}

PostDetails.defaultProps = {
  post: null,
  animated: false,
}

export default PostDetails
